exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (weex-theme: colmo) {\n.result-image[data-v-44d44e58] {\n    width: 6.4rem;\n    height: 3.06667rem;\n    margin-top: 2.66667rem;\n}\n}\n", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-result/colmo.css"],"names":[],"mappings":";AAAA;AACE;IACE,cAAa;IACb,mBAAc;IACd,uBAAkB;CACnB;CACF","file":"colmo.css","sourcesContent":["@media screen and (weex-theme: colmo) {\n  .result-image {\n    width: 480px;\n    height: 230px;\n    margin-top: 200px;\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44d44e58","scoped":true,"hasInlineConfig":false}!./packages/dof-result/colmo.css
// module id = 183
// module chunks = 0 1